import { createRoot } from 'react-dom/client';
import { ConfigProvider } from '@mantis-theme/contexts/ConfigContext.tsx';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

import './index.css';

createRoot(document.getElementById('root')!).render(
  <ConfigProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>,
);
